import { DEFAULT_FEATURE_FLAGS, type FeatureFlagMap, type FeatureFlagName } from './flags.config';

/**
 * Reads feature flags from environment variables per ADR-007 (env-based source
 * for this phase; a Supabase `settings`-backed source is a future, additive option).
 */
export class FlagProvider {
  private readonly flags: FeatureFlagMap;

  constructor(source: Record<string, string | undefined>) {
    this.flags = {
      gallery: this.readFlag(source, 'VITE_FEATURE_GALLERY', DEFAULT_FEATURE_FLAGS.gallery),
      investment: this.readFlag(source, 'VITE_FEATURE_INVESTMENT', DEFAULT_FEATURE_FLAGS.investment),
      career: this.readFlag(source, 'VITE_FEATURE_CAREER', DEFAULT_FEATURE_FLAGS.career),
      blog: this.readFlag(source, 'VITE_FEATURE_BLOG', DEFAULT_FEATURE_FLAGS.blog),
      // marketplace is never read from the environment: always the reserved default.
      marketplace: DEFAULT_FEATURE_FLAGS.marketplace
    };
  }

  private readFlag(
    source: Record<string, string | undefined>,
    key: string,
    fallback: boolean
  ): boolean {
    const raw = source[key];
    if (raw === undefined) {
      return fallback;
    }
    return raw === 'true';
  }

  public isEnabled(name: FeatureFlagName): boolean {
    return this.flags[name];
  }

  public getAll(): Readonly<FeatureFlagMap> {
    return this.flags;
  }
}
